// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__100OC","content":"styles_content__2Qhlr"};